/**
 * TripStatusBadge — kleine Statusanzeige für eine Dienstreise (RK-7).
 *
 * v5 (plan-ux-reisekosten-align.md §3): Umbau auf `common/Badge` statt
 * eigener Roh-Farb-Klassen — Text-Badge mit App-weiter Tone-Sprache
 * (`draft→caution`, `settled→success`, `cancelled→danger`), Muster
 * `inbox/UnifiedStatusBadge.tsx` (draft/booked) bzw.
 * `CancellationStatusChip.tsx` (danger). Bewusst KEIN `StatusChip` (kein
 * `detail`-Langform-i18n-Bedarf, keine Klick-in-klickbarer-Row-Kollision —
 * s. Architekt-Begründung Spec §3). Props-Signatur unverändert, kein
 * Consumer-Delta.
 *
 * @module components/travel/TripStatusBadge
 */

import React from 'react';
import { useTranslation } from 'react-i18next';
import { Badge, BadgeTone } from '../common/Badge';
import { TravelTripStatus } from '../../types/travelTypes';

interface TripStatusBadgeProps {
  status: TravelTripStatus;
}

const TONE_BY_STATUS: Record<TravelTripStatus, BadgeTone> = {
  draft: 'caution',
  settled: 'success',
  cancelled: 'danger',
};

/**
 * Renders a small colored badge for a {@link TravelTripStatus}.
 *
 * @param status - Lebenszyklus-Status der Reise.
 */
const TripStatusBadge: React.FC<TripStatusBadgeProps> = ({ status }) => {
  const { t } = useTranslation('travel');

  return (
    <Badge tone={TONE_BY_STATUS[status]} className="whitespace-nowrap">
      {t(`status.${status}`)}
    </Badge>
  );
};

export default TripStatusBadge;
